/**
 * Create the store with dynamic reducers
 */

import { configureStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers';
import rootSaga from './containers/App/appSaga';
import { createBrowserHistory } from 'history';

const { routerMiddleware } = createReduxHistoryContext({
    history: createBrowserHistory(),
});

const sagaMiddleware = createSagaMiddleware();

const setupStore = (initialState = {}) => {
    // Create the store with two middlewares
    // 1. sagaMiddleware: Makes redux-sagas work
    // 2. routerMiddleware: Syncs the location/URL path to the state

    const store = configureStore({
        reducer: rootReducer,
        preloadedState: initialState,
        devTools: process.env.NODE_ENV !== 'production',
        middleware: () => [sagaMiddleware, routerMiddleware],
    });

    // Extensions
    store.runSaga = sagaMiddleware.run;
    store.injectedReducers = {}; // Reducer registry
    store.injectedSagas = {}; // Saga registry
    store.runSaga(rootSaga);

    return store;
};

export default setupStore;
